var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.25 2.16667H12.85C12.85 1.8353 12.5814 1.56667 12.25 1.56667V2.16667ZM1.75 2.16667L1.65136 1.57483C1.36205 1.62305 1.15 1.87336 1.15 2.16667H1.75ZM8.75 1H9.35C9.35 0.823629 9.2724 0.65619 9.13783 0.542188C9.00325 0.428186 8.82533 0.379168 8.65136 0.408164L8.75 1ZM7.01667 8C7.01667 7.66863 6.74804 7.4 6.41667 7.4C6.0853 7.4 5.81667 7.66863 5.81667 8H7.01667ZM5.81667 9.16667C5.81667 9.49804 6.0853 9.76667 6.41667 9.76667C6.74804 9.76667 7.01667 9.49804 7.01667 9.16667H5.81667ZM8.75 2.76667H12.25V1.56667H8.75V2.76667ZM11.65 2.16667V15H12.85V2.16667H11.65ZM2.35 15V2.16667H1.15V15H2.35ZM1.84864 2.7585L8.84864 1.59184L8.65136 0.408164L1.65136 1.57483L1.84864 2.7585ZM8.15 1V15H9.35V1H8.15ZM5.81667 8V9.16667H7.01667V8H5.81667ZM0 15.6H14V14.4H0V15.6Z",
    fill: "#627790"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.a63d09a03bdfd411c8a34c0b8e58c35b.svg";
export { ForwardRef as ReactComponent };